function ReviewsSection() {
  const { SectionEyebrow } = window.AppComponents;
  const { reviews } = window.AppData.siteContent;

  return (
    <section id="reviews" className="py-9">
      <div className="mb-6 max-w-3xl">
        <SectionEyebrow>Customer stories</SectionEyebrow>
        <h2 className="mt-4 font-display text-4xl font-bold tracking-[-0.05em] text-ink md:text-5xl">
          People want peace of mind. We help them get there faster.
        </h2>
      </div>

      <div className="grid gap-5 lg:grid-cols-3">
        {reviews.map((review) => (
          <article
            key={review.name}
            className="rounded-[26px] border border-white/80 bg-white/80 p-6 shadow-glow backdrop-blur-xl"
          >
            <p className="min-h-[110px] text-base leading-8 text-slate-500">
              "{review.quote}"
            </p>
            <strong className="mt-3 block">{review.name}</strong>
            <span className="block text-sm text-slate-500">{review.role}</span>
          </article>
        ))}
      </div>
    </section>
  );
}

window.AppSections = window.AppSections || {};
window.AppSections.ReviewsSection = ReviewsSection;
